import React, { useState, useMemo } from 'react';

const EMOJI_CATEGORIES = [
  {
    name: 'Smileys',
    icon: '😊',
    emojis: [
      { char: '😀', name: 'grinning face' },
      { char: '😃', name: 'smiling face with big eyes' },
      { char: '😄', name: 'grinning face with smiling eyes' },
      { char: '😁', name: 'beaming face with smiling eyes' },
      { char: '😆', name: 'grinning squinting face' },
      { char: '😅', name: 'grinning face with sweat' },
      { char: '😂', name: 'face with tears of joy' },
      { char: '🤣', name: 'rolling on the floor laughing' },
      { char: '🥲', name: 'smiling face with tear' },
      { char: '☺️', name: 'smiling face' },
      { char: '😊', name: 'smiling face with smiling eyes' },
      { char: '😇', name: 'smiling face with halo' },
      { char: '🙂', name: 'slightly smiling face' },
      { char: '🙃', name: 'upside-down face' },
      { char: '😉', name: 'winking face' },
      { char: '😌', name: 'relieved face' },
      { char: '😍', name: 'smiling face with heart-eyes' },
      { char: '🥰', name: 'smiling face with hearts' },
      { char: '😘', name: 'face blowing a kiss' },
      { char: '😋', name: 'face savoring food' },
      { char: '😛', name: 'face with tongue' },
      { char: '😜', name: 'winking face with tongue' },
      { char: '🤪', name: 'zany face' },
      { char: '🤨', name: 'face with raised eyebrow' },
      { char: '🧐', name: 'face with monocle' },
      { char: '🤓', name: 'nerd face' },
      { char: '😎', name: 'smiling face with sunglasses' },
      { char: '🤩', name: 'star-struck' },
      { char: '🥳', name: 'partying face' },
      { char: '😏', name: 'smirking face' },
      { char: '😒', name: 'unamused face' },
      { char: '😞', name: 'disappointed face' },
      { char: '😔', name: 'pensive face' },
      { char: '😟', name: 'worried face' },
      { char: '😕', name: 'confused face' },
      { char: '🙁', name: 'slightly frowning face' },
      { char: '☹️', name: 'frowning face' },
      { char: '🥺', name: 'pleading face' },
      { char: '😢', name: 'crying face' },
      { char: '😭', name: 'loudly crying face' },
      { char: '😤', name: 'face with steam from nose' },
      { char: '😠', name: 'angry face' },
      { char: '😡', name: 'pouting face' },
      { char: '🤬', name: 'face with symbols on mouth' },
      { char: '🤯', name: 'exploding head' },
      { char: '😳', name: 'flushed face' },
      { char: '🥵', name: 'hot face' },
      { char: '🥶', name: 'cold face' },
      { char: '😱', name: 'face screaming in fear' },
      { char: '😨', name: 'fearful face' },
      { char: '😰', name: 'anxious face with sweat' },
      { char: '😥', name: 'sad but relieved face' },
      { char: '😓', name: 'downcast face with sweat' },
      { char: '🤗', name: 'smiling face with open hands' },
      { char: '🤔', name: 'thinking face' },
      { char: '🤫', name: 'shushing face' },
      { char: '😴', name: 'sleeping face' }
    ]
  },
  {
    name: 'Gestures',
    icon: '👍',
    emojis: [
      { char: '👍', name: 'thumbs up' },
      { char: '👎', name: 'thumbs down' },
      { char: '👌', name: 'ok hand' },
      { char: '✌️', name: 'victory hand' },
      { char: '🤞', name: 'crossed fingers' },
      { char: '🤟', name: 'love-you gesture' },
      { char: '🤘', name: 'sign of the horns' },
      { char: '🤙', name: 'call me hand' },
      { char: '👈', name: 'backhand index pointing left' },
      { char: '👉', name: 'backhand index pointing right' },
      { char: '👆', name: 'backhand index pointing up' },
      { char: '👇', name: 'backhand index pointing down' },
      { char: '☝️', name: 'index pointing up' },
      { char: '👋', name: 'waving hand' },
      { char: '🤚', name: 'raised back of hand' },
      { char: '✋', name: 'raised hand' },
      { char: '👏', name: 'clapping hands' },
      { char: '🙌', name: 'raising hands' },
      { char: '👐', name: 'open hands' },
      { char: '🤲', name: 'palms up together' },
      { char: '🤝', name: 'handshake' },
      { char: '🙏', name: 'folded hands pray please thanks' },
      { char: '💪', name: 'flexed biceps strong' },
      { char: '👀', name: 'eyes' },
      { char: '🧠', name: 'brain' }
    ]
  },
  {
    name: 'Hearts & Fire',
    icon: '❤️',
    emojis: [
      { char: '❤️', name: 'red heart love' },
      { char: '🧡', name: 'orange heart' },
      { char: '💛', name: 'yellow heart' },
      { char: '💚', name: 'green heart' },
      { char: '💙', name: 'blue heart' },
      { char: '💜', name: 'purple heart' },
      { char: '🖤', name: 'black heart' },
      { char: '🤍', name: 'white heart' },
      { char: '💔', name: 'broken heart' },
      { char: '❤️‍🔥', name: 'heart on fire' },
      { char: '💕', name: 'two hearts' },
      { char: '💖', name: 'sparkling heart' },
      { char: '💘', name: 'heart with arrow' },
      { char: '🔥', name: 'fire lit hot' },
      { char: '✨', name: 'sparkles' },
      { char: '⭐', name: 'star' },
      { char: '🌟', name: 'glowing star' },
      { char: '⚡', name: 'high voltage zap' },
      { char: '💥', name: 'collision boom' },
      { char: '💯', name: 'hundred points perfect' },
      { char: '🎉', name: 'party popper celebrate' },
      { char: '🎊', name: 'confetti ball' },
      { char: '🎈', name: 'balloon' },
      { char: '🏆', name: 'trophy winner' },
      { char: '👑', name: 'crown king queen' },
      { char: '💎', name: 'gem stone diamond' }
    ]
  },
  {
    name: 'Work & Objects',
    icon: '🚀',
    emojis: [
      { char: '🚀', name: 'rocket launch fast' },
      { char: '🎯', name: 'bullseye target goal' },
      { char: '💡', name: 'light bulb idea' },
      { char: '💻', name: 'laptop computer dev' },
      { char: '📱', name: 'mobile phone' },
      { char: '💼', name: 'briefcase work' },
      { char: '📅', name: 'calendar date' },
      { char: '⏰', name: 'alarm clock time' },
      { char: '✅', name: 'check mark done' },
      { char: '❌', name: 'cross mark cancel' },
      { char: '⚠️', name: 'warning alert' },
      { char: '❓', name: 'question mark' },
      { char: '❗', name: 'exclamation mark' },
      { char: '📌', name: 'pushpin pin' },
      { char: '📎', name: 'paperclip attach' },
      { char: '📝', name: 'memo note writing' },
      { char: '✏️', name: 'pencil edit' },
      { char: '🔔', name: 'bell notify' },
      { char: '💬', name: 'speech balloon comment' },
      { char: '📢', name: 'loudspeaker announcement' },
      { char: '🛠️', name: 'hammer and wrench fix' },
      { char: '⚙️', name: 'gear settings' },
      { char: '🔒', name: 'locked security' },
      { char: '🔑', name: 'key access' }
    ]
  }
];

export default function EmojiPicker({
  onEmojiClick,
  height = '350px',
  width = '310px',
  theme = 'light'
}) {
  const isDark = theme === 'dark';
  const [activeTab, setActiveTab] = useState(0);
  const [search, setSearch] = useState('');

  const filteredEmojis = useMemo(() => {
    if (!search.trim()) return null;
    const q = search.toLowerCase().trim();
    const all = [];
    EMOJI_CATEGORIES.forEach((cat) => {
      cat.emojis.forEach((item) => {
        if (item.name.toLowerCase().includes(q) || item.char.includes(q)) {
          all.push(item);
        }
      });
    });
    return all;
  }, [search]);

  const handlePick = (emojiChar) => {
    if (typeof onEmojiClick === 'function') {
      onEmojiClick({ emoji: emojiChar, native: emojiChar });
    }
  };

  const bg = isDark ? '#1f2937' : '#ffffff';
  const text = isDark ? '#f3f4f6' : '#111827';
  const border = isDark ? '#374151' : '#e5e7eb';
  const inputBg = isDark ? '#111827' : '#f9fafb';
  const hoverBg = isDark ? '#374151' : '#f3f4f6';

  return (
    <div
      style={{
        width,
        height,
        backgroundColor: bg,
        color: text,
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 8,
        overflow: 'hidden',
        fontFamily: 'inherit',
        fontSize: 14,
        boxSizing: 'border-box'
      }}
    >
      {/* Search Input */}
      <div style={{ padding: '8px 10px 4px 10px' }}>
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search emojis..."
          style={{
            width: '100%',
            padding: '6px 10px',
            fontSize: 13,
            borderRadius: 6,
            border: `1px solid ${border}`,
            backgroundColor: inputBg,
            color: text,
            outline: 'none',
            boxSizing: 'border-box'
          }}
        />
      </div>

      {/* Categories Tabs */}
      {!search.trim() && (
        <div
          style={{
            display: 'flex',
            borderBottom: `1px solid ${border}`,
            padding: '2px 6px',
            gap: 4
          }}
        >
          {EMOJI_CATEGORIES.map((cat, idx) => (
            <button
              key={cat.name}
              type="button"
              onClick={() => setActiveTab(idx)}
              title={cat.name}
              style={{
                background: activeTab === idx ? hoverBg : 'transparent',
                border: 'none',
                cursor: 'pointer',
                borderRadius: 4,
                padding: '4px 8px',
                fontSize: 16,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                outline: 'none'
              }}
            >
              {cat.icon}
            </button>
          ))}
        </div>
      )}

      {/* Emoji Grid */}
      <div
        style={{
          flex: 1,
          overflowY: 'auto',
          padding: 8,
          display: 'grid',
          gridTemplateColumns: 'repeat(7, 1fr)',
          gap: 4,
          alignContent: 'start'
        }}
      >
        {(filteredEmojis || EMOJI_CATEGORIES[activeTab]?.emojis || []).map((item, index) => (
          <button
            key={item.char + '-' + index}
            type="button"
            onClick={() => handlePick(item.char)}
            title={item.name}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              fontSize: 20,
              padding: '6px 0',
              borderRadius: 6,
              transition: 'background-color 0.15s',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              lineHeight: 1
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = hoverBg;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            {item.char}
          </button>
        ))}
      </div>
    </div>
  );
}
